import BaseApi from "../../../BaseApi";


export default class DmrTrackingGroups extends BaseApi {

    construct() {}

    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1") 
                + "department-membership-requests/tracking-groups";
    }

    static async create(payload) {
        return this.post(this.getApiUrl(), payload);
    }

    static async index(filters = {}) {
        return this.get(this.getApiUrl(), filters);
    }

    static async all(filters = {}) {
        return this.index({params: filters});
    }

    static async update(id, payload) {
        return this.patch(`${this.getApiUrl()}/${id}`, payload);
    }

    static async delete(id, payload = {}) {
        return this.getAxiosInstance().delete(`${this.getApiUrl()}/${id}`, {
            data: payload,
        });
    }

    static async show(id) {
        return this.get(`${this.getApiUrl()}/${id}`);
    }

    static async getEligibleManagers() {
        return this.get(`${this.getApiUrl()}/eligible-managers`, {})
    }

    static async listActiveUsers() {
        return this.get(`${this.getApiUrl()}/active-users`, {})
    }
}